import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(main)/quiz/[slug]/result/[id]/client.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/quiz/score_thumbnails/wojak_10.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/quiz/score_thumbnails/wojak_20.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/quiz/score_thumbnails/wojak_30.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/quiz/score_thumbnails/wojak_40.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/quiz/score_thumbnails/wojak_5.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/quiz/score_thumbnails/wojak_50.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/quiz/score_thumbnails/wojak_60.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/quiz/score_thumbnails/wojak_70.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/quiz/score_thumbnails/wojak_80.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/quiz/score_thumbnails/wojak_90.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/quiz/score_thumbnails/wojak_94.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/quiz/score_thumbnails/wojak_95.webp");
